/** 商品配置名称 → product_type（pro_type 字典） */
export const PRODUCT_CONFIG_TYPE_BY_NAME = {
  标品: 1,
  孤品: 2,
  瑕疵品: 3,
  签约品: 4,
  签约: 4,
  定制品: 5,
  定制: 5,
  盲盒: 6,
  默认配置: 1,
}

export const PRODUCT_DEFAULT_TYPE = 1

export function resolveProductTypeFromConfigName(name) {
  const n = String(name || '').trim()
  if (!n) return null
  if (PRODUCT_CONFIG_TYPE_BY_NAME[n] != null) return PRODUCT_CONFIG_TYPE_BY_NAME[n]
  for (const [key, val] of Object.entries(PRODUCT_CONFIG_TYPE_BY_NAME)) {
    if (n.includes(key)) return val
  }
  return null
}

export function resolveProductTypeFromConfig(cfg) {
  if (cfg?.type != null && Number(cfg.type) > 0) return Number(cfg.type)
  return resolveProductTypeFromConfigName(cfg?.name)
}

export function buildProductTypeOptionsFromConfigs(configs = []) {
  return (configs || [])
    .map((cfg) => {
      const type = resolveProductTypeFromConfig(cfg)
      if (type == null) return null
      return { label: cfg.name, value: type, configId: cfg.id }
    })
    .filter(Boolean)
    .sort((a, b) => a.value - b.value)
}

export function findDefaultProductConfig(configs = []) {
  const list = configs || []
  return list.find((cfg) => resolveProductTypeFromConfig(cfg) === PRODUCT_DEFAULT_TYPE)
    || list.find((cfg) => cfg.name === '标品' || String(cfg.name || '').includes('标品'))
    || list[0]
    || null
}

export function parseConfigFormJson(cfg) {
  if (!cfg) return {}
  let formJson = cfg.formJson
  if (typeof formJson === 'string') {
    try {
      formJson = JSON.parse(formJson)
    } catch (e) {
      formJson = {}
    }
  }
  return formJson && typeof formJson === 'object' ? formJson : {}
}

export function isConfigFormJsonEmpty(cfg) {
  const formJson = parseConfigFormJson(cfg)
  return !Array.isArray(formJson.fields) || formJson.fields.length === 0
}

export function findProductConfigByType(configs = [], type) {
  if (type == null || type === '') return null
  const list = configs || []
  const matched = list.find((cfg) => String(resolveProductTypeFromConfig(cfg)) === String(type))
  if (matched) return matched
  return list.find((cfg) => resolveProductTypeFromConfig(cfg) === PRODUCT_DEFAULT_TYPE) || list[0] || null
}
